var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgViewDoc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 16.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5z",
    fill: "#4054B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.61 14.674a5.4 5.4 0 0 0-4.86-3.424 5.4 5.4 0 0 0-4.86 3.424L8.75 15l.14.326a5.4 5.4 0 0 0 4.86 3.424 5.4 5.4 0 0 0 4.86-3.424l.14-.326-.14-.326zM13.75 17.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z",
    fill: "#4054B2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 17.5H5v-15h5v3.75a1.254 1.254 0 0 0 1.25 1.25H15V10h1.25V6.25a.568.568 0 0 0-.188-.438l-4.375-4.375a.567.567 0 0 0-.437-.187H5A1.254 1.254 0 0 0 3.75 2.5v15A1.254 1.254 0 0 0 5 18.75h2.5V17.5zm3.75-14.75 3.5 3.5h-3.5v-3.5z",
    fill: "#4054B2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewDoc);
export default __webpack_public_path__ + "static/media/viewDoc.0c0576ee2eee2d6af694c5d85c46809c.svg";
export { ForwardRef as ReactComponent };